import { cn } from "web-design-system";
import { Amount } from "../primitives/amount";
import { Units } from "../primitives/units";

interface Props {
  amount: string;
  units: string;
  nav: string;
  className?: string;
}

export function HoldingDetails(props: Props) {
  const { amount, units, nav, className } = props;

  return (
    <div
      className={cn(
        "col-span-2 bg-muted p-3 rounded-lg flex border border-border justify-between items-center",
        className
      )}
    >
      <div className="flex flex-col items-center gap-1">
        <span className="text-xs text-muted-foreground">Approx Value</span>
        <span className="text-sm font-medium">
          <Amount>{amount}</Amount>
        </span>
      </div>
      <div className="flex flex-col items-center gap-1">
        <span className="text-xs text-muted-foreground">Units</span>
        <span className="text-sm font-medium">
          <Units>{units}</Units>
        </span>
      </div>
      <div className="flex flex-col items-center gap-1">
        <span className="text-xs text-muted-foreground">Current NAV</span>
        <span className="text-sm font-medium">
          <Amount>{nav}</Amount>
        </span>
      </div>
    </div>
  );
}
